<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
            ></head-menu-filter>

            <div class="row mb-2">
              <div class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10">

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.angebotNr"
                        class="form-control input"
                        type="number"
                        placeholder=" "
                        min="0"
                      />
                      <label>{{ $t("global.number") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.from") }}</label>
                      <input
                        v-model="filters.von"
                        type="date"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <label>{{ $t("global.till") }}</label>
                      <input
                        v-model="filters.bis"
                        type="date"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.belegungsstatus"
                        label="bezeichnung"
                        :options="belegungsstati"
                        :placeholder="$t('global.status')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>
                      </v-select>
                      <label>{{ $t("global.status") }}</label>
                    </div>
                  </div>
                </div>


                <!--TODO Belegungstatus -->

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-firma
                      id="zeitraumliste-hof"
                      :firma="filters.firma"
                      :editable="true"
                      :allowOpen="true"
                      :label="$t('portal.farm')"
                      @confirmed="setHof"
                    />
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <single-select-person
                      id="ansprechsperson"
                      :person="filters.ansprechsperson"
                      :label="$t('portal.mainContactPerson')"
                      :allowOpen="false"
                      :activeonly="false"
                      editable
                      @confirmed="setFilterAnsprechsperson"
                    />
                  </div>
                </div>

                <!-- TODO Alpbetrieb -->

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.ort"
                        class="form-control input"
                        type="text"
                        :placeholder="$t('global.city')"
                      />
                      <label>{{ $t("global.city") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.kanton"
                        class="form-control input"
                        type="text"
                        :placeholder="$t('global.canton')"
                      />
                      <label>{{ $t("global.canton") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.vermittlungsstelle"
                        label="bezeichnung"
                        :options="vermittlungsstellen"
                        :placeholder="$t('global.switchboard')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>
                      </v-select>
                      <label>{{ $t("global.switchboard") }}</label>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="filters.auswahlEinsatzbereich"
                        label="bezeichnung"
                        :options="einsatzbereiche"
                        :placeholder="$t('global.areasofapplication')"
                        multiple
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>
                      </v-select>
                      <label>{{ $t("global.areasofapplication") }}</label>
                    </div>
                  </div>
                </div>

                <!-- Weitere Filterelemente können hier hinzugefügt werden -->

                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>

        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.periods')"
              :anzahl="anzahlDaten"
              :anzahlAusFilter="anzahlDatenFilter"
              :gesamtanzahl="gesamtanzahl"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                  </div>
                  <div class="mr-4 float-right">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                      v-if="berechtigungen.m_notizen.delete"
                      :disabled="selectedIds.length === 0"
                      :title="
                        selectedIds.length === 0
                          ? $t('global.selectminone')
                          : ''
                      "
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      {{ $t("global.delete") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    small
                    tbody-tr-class="item"
                    :items="listData"
                    :fields="fields"
                    :sort-compare="sortDates"
                    sort-icon-left
                    fixed
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template slot="top-row" slot-scope="{ fields }">
                      <td
                        class="no-pointer"
                        v-for="field in fields"
                        :key="field.key"
                      >
                        <b-input
                          v-if="
                            field.key != 'selected' && field.searchable != false
                          "
                          size="sm"
                          v-model="filters[field.key]"
                          :placeholder="field.label"
                        />
                      </td>
                    </template>

                    <template v-slot:cell(alpbetrieb)="row">
                      {{ row.item.alpbetrieb ? "✓" : "" }}
                    </template>

                    <template v-slot:head(selected)="header">
                      <b-form-checkbox
                        ref="headerCheckbox"
                        v-model="header.selected"
                        @input="selectAllRows(header)"
                      ></b-form-checkbox>
                    </template>

                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'app-api')"
                  >
                    <div slot="spinner">{{ $t("global.loadmoredata") }}</div>
                    <div slot="no-more">{{ $t("global.nofurtherdata") }}</div>
                    <div slot="no-results">
                      {{ $t("global.nofurtherdatafound") }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <loeschen-modal
      id="zeitraum-loeschen-modal"
      :selectedIds="this.selectedIds"
      :multiple="true"
      @confirmed="loeschen"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
import page from "@/mixins/Page";
import dashboard from "@/mixins/Dashboard";
import filter from "@/mixins/FilterNew";
import store from "@/store";
import Navbar from "@/components/Navbar.vue";
import HeadMenuFilter from "@/components/HeadMenuFilter.vue";
import FilterSearchResetButton from "@/components/Buttons/FilterSearchResetButton.vue";
import HeadMenu from "@/components/HeadMenu.vue";
import LoeschenModal from "@/components/Modals/LoeschenModal.vue";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";

export default {
  name: "Zeitraumliste",
  components: {
    SingleSelectPerson,
    SingleSelectFirma,
    LoeschenModal,
    HeadMenu,
    FilterSearchResetButton,
    HeadMenuFilter,
    Navbar
  },
  metaInfo() {
    return {
      titleTemplate: () => {
        return this.$t("global.periods");
      }
    };
  },
  mixins: [page, dashboard, filter],
  props: {},
  store,
  data() {
    return {};
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "", sortable: false, searchable: false },
        {
          key: "angebotNr",
          label: this.$t("global.number"),
          sortable: true,
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        },
        {
          key: "von",
          sortable: true,
          searchable: false,
          label: this.$t("global.From"),
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        },
        {
          key: "bis",
          sortable: true,
          searchable: false,
          label: this.$t("global.till"),
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        },
        {
          key: "belegungsstatus",
          label: this.$t("global.status"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value) return value.bezeichnung;
            return "-";
          }
        },
        {
          key: "betrieb",
          label: this.$t("portal.farm"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        },
        {
          key: "ansprechsperson",
          label: this.$t("portal.mainContactPerson"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value)
              return `${value.vorname ? value.vorname : ""} ${
                value.nachname ? value.nachname : ""
              }`;
            return "-";
          }
        },
        {
          key: "alpbetrieb",
          label: this.$t("portal.timeBasisCompany"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value != null) {
              return value;
            }
            return false;
          }
        },
        {
          key: "ort",
          label: this.$t("global.city"),
          sortable: true,
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        },
        {
          key: "kanton",
          label: this.$t("global.canton"),
          sortable: true,
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        },
        {
          key: "vermittlungsstelle",
          label: this.$t("global.switchboard"),
          sortable: true,
          searchable: false,
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        },
        {
          key: "aufgabenbereiche",
          sortable: true,
          searchable: false,
          label: this.$t("global.areasofapplication"),
          formatter: (value) => {
            if (value)
              return value;
            return "-";
          }
        },
        {
          key: "anzahl",
          label: this.$t("global.workplaces"),
          sortable: true,
          formatter: (value) => {
            if (value) return value;
            return "-";
          }
        }
      ];
    },
    queryParams: function() {
      let params = {};

      params.filterAngebotNr = this.setQueryParam(this.filters.angebotNr);
      params.filterVon = this.setQueryParam(this.filters.von);
      params.filterBis = this.setQueryParam(this.filters.bis);
      params.filterBelegungsstatus = this.setQueryParam(
        this.filters.belegungsstatus
      );
      params.filterFirma = this.setQueryParam(this.filters.firma?.id);
      params.filterAnsprechsperson = this.setQueryParam(this.filters.ansprechsperson?.id);
      //TODO params.filterAlpbetrieb = this.setQueryParam(this.filters.alpbetrieb);
      params.filterOrt = this.setQueryParam(this.filters.ort);
      params.filterKanton = this.setQueryParam(this.filters.kanton);
      params.filterVermittlungsstelle = this.setQueryParam(
        this.filters.vermittlungsstelle?.join(",")
      );
      params.filterBelegungsstatus = this.setQueryParam(
        this.filters.belegungsstatus?.join(",")
      );
      params.filterEinsatzbereich = this.setQueryParam(
        this.filters.auswahlEinsatzbereich?.join(",")
      );

      params.count = this.setQueryParam(
        this.filters.count ? this.filters.count : 50
      );

      return params;
    },

    //Auswahlwerte
    einsatzbereiche() {
      if (this.$store) return this.$store.state.crm.einsatzbereiche;
      return [];
    },
    vermittlungsstellen() {
      if (this.$store) return this.$store.state.crm.vermittlungsstellen;
      return [];
    },
    belegungsstati() {
      if (this.$store) return this.$store.state.crm.belegungsstati;
      return [];
    }
  },
  created() {
    this.initFilter("zeitraumliste", "zeitraumliste/", false);
  },
  mounted() {
    if (this.einsatzbereiche?.length === 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);
  },
  methods: {

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "zeitraum-loeschen-modal");
    },

    details(zeitraum) {
      this.$router.push({
        name: "Angebot",
        params: { id: zeitraum.angebotId, anzeige: 0 }
      });
    },

    loeschen() {
      this.isBusy = true;

      AppApi.delete("zeitraum/", {
        data: this.selectedIds
      })
        .then(() => {
          this.$emit("confirmed");
          this.selectedIds = [];
          this.$router.go(0);
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    setFilterAnsprechsperson(person) {
      this.$set(this.filters, "ansprechsperson", person);
    },

    setHof(hof) {
      this.$set(this.filters, "firma", hof);
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id !== row.item.id);
      }
    }
  }
};
</script>
